import { render, staticRenderFns } from "./PublishProcedure.vue?vue&type=template&id=3547fd74&"
import script from "./PublishProcedure.vue?vue&type=script&lang=js&"
export * from "./PublishProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports